var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showSpectate)?_c('div',{key:_vm.endState},[_c('PrimaryButton',{staticClass:"c-swap-button o-primary-btn--modal-close c-modal__close-btn tutorial--glow",on:{"click":_vm.swap}},[_c('i',{staticClass:"fas fa-sync"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }